<template>
  <div class="wl-study-ceter-main-wrapper">
    <div class="head-banner-con" :style="{backgroundImage: 'url(' + defaultCover + ')'}"></div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultCover:
        "https://file.clpp.org.cn/ykt/ori/dd6xaesrd5lfbwst9cqswg/D4mDRsDJ8YibMQNb.png"
    };
  }
};
</script>

<style lang="scss">
.wl-study-ceter-main-wrapper {
  margin-top: -40px;
  .head-banner-con {
    height: 200px;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
  }
}
// 移动端样式
@media only screen and (max-width:960px) {
    .wl-study-ceter-main-wrapper { 
        margin-top:0;
         .head-banner-con { 
             height: 75px;
         }
    }
}
</style>

